module.exports = ".kan-service-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/service-dialog/component.scss
// module id = ./src/modules/admin/dialogs/service-dialog/component.scss
// module chunks = main